import PropTypes from 'prop-types'
import { Component } from 'react'
import { kuiperClassNames } from '../../utils'

import './styles.scss'

function getSliderBar(currentValue, maxValue, className) {
  const widthPercent = (currentValue / maxValue) * 100
  const safeWidthPercent = Number.isFinite(widthPercent)
    ? Math.max(0, widthPercent)
    : 0
  return (
    <div
      className={kuiperClassNames('slider-bar', className)}
      style={{ width: `${safeWidthPercent}%` }}
    />
  )
}

export default class Slider extends Component {
  static propTypes = {
    availableValue: PropTypes.number,
    currentValue: PropTypes.number,
    disabled: PropTypes.bool,
    dragTargetPadX: PropTypes.number,
    dragTargetPadY: PropTypes.number,
    isActive: PropTypes.bool,
    maxValue: PropTypes.number,
    onChange: PropTypes.func,
    onChangeFinished: PropTypes.func,
  }

  static defaultProps = {
    dragTargetPadX: 5,
    dragTargetPadY: 5,
  }

  constructor(props) {
    super(props)
    this.state = {
      dragging: false,
    }

    this.onMouseDown = this.onMouseDown.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    this.onMouseUp = this.onMouseUp.bind(this)
  }

  computeNewValue(mouseEvent) {
    const offset = this.containerOffset
    const dragClientX = mouseEvent.clientX
    const clientWidth = this.containerWidth
    const percentage = Math.max(
      0,
      Math.min(1, (dragClientX - offset) / clientWidth)
    )
    const newCurrentValue = Math.floor(this.props.maxValue * percentage)
    return Number.isFinite(newCurrentValue) ? newCurrentValue : 0
  }

  get availableValue() {
    return this.props.availableValue
  }

  get containerOffset() {
    return this.container ? this.container.getBoundingClientRect().left : 0
  }

  get currentValue() {
    return this.props.currentValue
  }

  get containerWidth() {
    return this.container ? this.container.clientWidth : 0
  }

  get dragTarget() {
    const style = {
      left: `-${this.dragTargetPadX}px`,
      padding: `${this.dragTargetPadY}px ${this.dragTargetPadX}px`,
      top: `-${this.dragTargetPadY}px`,
    }

    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div
        className={kuiperClassNames('drag-target')}
        onMouseDown={this.onMouseDown}
        onMouseMove={this.onMouseMove}
        onMouseUp={this.onMouseUp}
        style={style}
      />
    )
  }

  get dragTargetPadX() {
    return this.props.dragTargetPadX
  }

  get dragTargetPadY() {
    return this.props.dragTargetPadY
  }

  get maxValue() {
    return this.props.maxValue
  }

  get sliderBarClasses() {
    return kuiperClassNames(
      'current-value',
      { 'is-active': this.props.isActive },
      { 'is-dragging': this.state.dragging }
    )
  }

  onMouseDown() {
    if (!this.props.disabled) {
      this.setState({
        dragging: true,
      })
    }
  }

  onMouseMove(e) {
    e.stopPropagation()
    if (this.state.dragging && this.props.onChange) {
      this.props.onChange(this.computeNewValue(e))
    }
  }

  onMouseUp() {
    if (this.state.dragging) {
      this.setState({ dragging: false })
      if (this.props.onChangeFinished) {
        this.props.onChangeFinished(this.currentValue)
      }
    }
  }

  render() {
    return (
      <div
        className={kuiperClassNames('slider')}
        ref={(container) => (this.container = container)}
      >
        <div className={kuiperClassNames('slider-bucket')}>
          {getSliderBar(this.availableValue, this.maxValue, 'available-value')}
          {getSliderBar(
            this.currentValue,
            this.maxValue,
            this.sliderBarClasses
          )}
        </div>
        {this.dragTarget}
      </div>
    )
  }
}
